export default "__VITE_ASSET__BH772bNH__"